<template>
  <div class="ellipsis">
    <div v-if="title" :style="{width: `${titleWidth}px`}">
      {{title}}
    </div>
    <div style="flex: 1">
      <div class="hidded" :style="{height:!show?'':type?'':line*lineheight+'px','line-height': lineheight+'px',textOverflow:title?'':'ellipsis'}">
        <div ref="thisslot">
          <slot></slot>
        </div>

        <div class="bottom">
          <span v-if="show&&!type">...</span>
          <span v-if="show&&title">
            <span class="colorsq" v-if="type" @click="type=false">点击收起&nbsp;▴</span>
            <span class="colorzk" v-else @click="type=true">查看更多&nbsp;▾</span>
          </span>
        </div>
      </div>
      <div v-if="show&&!title">
        <span class="colorsq" v-if="type" @click="type=false">点击收起&nbsp;▴</span>
        <span class="colorzk" v-else @click="type=true">查看更多&nbsp;▾</span>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  name: "ui-ellipsis",
  data(){
    return {
      type:false,//展开状态
      show:false,//是否折叠
    }
  },
  props:{
    title:{
      type:String,
      default:''
    },
    titleWidth:{
      type:[Number,String],
      default:'120'
    },
    line:{
      type:[Number,String],
      default:3,//默认3行
    },
    lineheight:{
      type:[Number,String],
      default:20,//默认行高
    }
  },
  mounted() {
    let height=this.$refs.thisslot.offsetHeight;
    if((this.lineheight*this.line)<height){
      this.show=true;
    }
  }
}
</script>

<style  lang="scss" scoped>
.ellipsis{
  display: flex;
  font-size: var(--FS3);
  .hidded{
    overflow: hidden;
    word-break: break-word;
    position: relative;
  }
  .bottom{
    position: absolute;bottom: 0;right: 0;background: #fff;
  }
  .colorzk{
    color: var(--Cfs2);
  }
  .colorsq{
    color: var(--Cdzs);
  }
}
</style>
